import { Button } from 'vnetwork-ui'
import { Download } from 'lucide-react'
import html2canvas from 'html2canvas'
import jsPDF from 'jspdf'
import * as XLSX from 'xlsx'
import dayjs from 'dayjs'

// Export chart to PDF
export const exportChartToPDF = async (
    chartRef: React.RefObject<HTMLDivElement>,
    filename: string
) => {
    if (!chartRef.current) return

    try {
        const canvas = await html2canvas(chartRef.current, {
            scale: 2,
            useCORS: true,
            logging: false,
        })

        const imgData = canvas.toDataURL('image/png')
        const pdf = new jsPDF('l', 'mm', 'a4')
        const pdfWidth = pdf.internal.pageSize.getWidth()
        const pdfHeight = (canvas.height * pdfWidth) / canvas.width

        pdf.addImage(imgData, 'PNG', 0, 10, pdfWidth, pdfHeight)
        pdf.save(`${filename}.pdf`)
    } catch (error) {
        console.error('Export PDF error:', error)
    }
}

// Export table data to Excel
export const exportToExcel = (
    data: any[],
    filename: string,
    sheetName = 'Sheet1'
) => {
    if (!data || data.length === 0) return

    const ws = XLSX.utils.json_to_sheet(data)
    const wb = XLSX.utils.book_new()
    XLSX.utils.book_append_sheet(wb, ws, sheetName)
    XLSX.writeFile(wb, `${filename}.xlsx`)
}

// PDF Export Button Component
interface PDFExportButtonProps {
    chartRef: React.RefObject<HTMLDivElement>
    filename: string
    className?: string
}

export const PDFExportButton = ({
    chartRef,
    filename,
    className = '',
}: PDFExportButtonProps) => (
    <Button
        size="small"
        variant="text"
        onClick={() =>
            exportChartToPDF(
                chartRef,
                `${filename}-${dayjs().format('YYYY-MM-DD')}`
            )
        }
        className={`!p-1 ${className}`}
        title="Export to PDF"
    >
        <Download className="w-4 h-4" />
    </Button>
)

// Excel Export Button Component
interface ExcelExportButtonProps {
    data: any[]
    filename: string
    className?: string
    sheetName?: string
}

export const ExcelExportButton = ({
    data,
    filename,
    className = '',
    sheetName,
}: ExcelExportButtonProps) => (
    <Button
        size="small"
        variant="text"
        onClick={() =>
            exportToExcel(
                data,
                `${filename}-${dayjs().format('YYYY-MM-DD')}`,
                sheetName
            )
        }
        className={`!p-1 ${className}`}
        title="Export to Excel"
    >
        <Download className="w-4 h-4" />
    </Button>
)
